import { styled } from '@mui/material';
import { Lightbulb } from '@mui/icons-material';
import React from 'react';
import { Colors, Text } from 'library';

export default function LateCancellationWarning() {
    return (
        <WarningBox>
            <Lightbulb sx={{ color: Colors.accent, fontSize: 20, flexShrink: 0, marginTop: '2px' }} />
            <TextColumn>
                <Text variant="body2" textStyle={{ color: Colors.primary }}>
                    <b>Cancellation Policy: </b> For booked shifts cancelled within 2 hours of the shift start time, you
                    will be responsible for paying for 2 hours of the shift.
                </Text>
                <Text variant="body2" textStyle={{ color: Colors.primary }}>
                    <b>Hiring Policy: </b> After a worker completes 120 hours at your center, you can onboard them
                    permanently to your staff at no cost — just let your Tandem account manager know!
                </Text>
            </TextColumn>
        </WarningBox>
    );
}

const WarningBox = styled('div')({
    marginTop: 10,
    padding: '10px 14px',
    backgroundColor: Colors.accentSoft,
    border: `1px solid ${Colors.accent}`,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
});

const TextColumn = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
});
